import { Editor } from "@tinymce/tinymce-react";
import React, { ReactNode, useEffect, useState } from 'react'
import { Button, Card, Col, FormCheck, FormControl, FormSelect, Modal, Row } from "react-bootstrap";
import { config_editor } from "../Funciones";
import { Dash, Gear, XLg } from "react-bootstrap-icons";
import { ContentSelector } from './Admin/Contents/ContentSelector';
import { TagList, TagSelector } from "./Admin/Tags/Manager";

const modules: string[] = [
	"Template",
	"HTML",
	"SingleContent",
	"Category",
	"Latest",
	"Columns",
	"Stack",
	"Menu",
	"Breadcrumb",
	"Carousel",
	"List"
]
export type ModuleFieldType = "text" | "select" | "boolean" | "number" | "editor" | "textarea" | "check" | "content" | "nav" | "fullnav" | "tags" | "custom";

export type ModuleField = {
	name: string;
	title: string;
	description: string;
	type: ModuleFieldType;
	elements?: { value: string; title: string }[]; //para select
	required: boolean;
	default: any;
	controls?: React.FC<{ value: any, onChange: Function, nav: any[], fullNav: any[], config: Map<string, any> }>;
	mapSaveData?: Function;
	initializeData?: Function;
}
export const ModuleByName = async (name: string) => {
	var m = await import("./Modules/" + name)
	return new m.default();
}
export const ModuleList = async (template?: boolean) => {
	var list: any[] = [];
	for (var i = 0; i < modules.length; i++) {
		var name = modules[i]
		if (template && template === true) {

		}
		else {
			if (name === "Template") continue;
		}
		list.push(await ModuleByName(name))
	}
	return list;
}

export abstract class ModuleClass {
	abstract getModuleName(): string;
	abstract getModuleTitle(): string;
	abstract getDescription(): string;
	abstract getIcon(size: number): ReactNode;
	abstract getFields(): ModuleField[];

	abstract Component: React.FC<{ data: Map<string, any>, moduleData?: any, nav?: any[], currentPage?: string }>;
}
export type ModuleData = {
	Module?: ModuleClass;
	Data?: Map<string, any>;
	Instance: number;
	Collapsed?: boolean;
}
export const ModuleSelector: React.FC<{ onSelect: Function, children: ReactNode, template?: boolean }> = ({ onSelect, children, template }) => {

	const [mostrar, setMostrar] = useState(false)
	const [modules, setModules] = useState<any[]>([])

	const selection = (m: any) => {
		setMostrar(false)
		onSelect(m)
	}

	const init = async () => {
		var list = await ModuleList(template)
		setModules(list)
	}

	useEffect(() => {
		init()
		// eslint-disable-next-line
	}, [])

	return <>
		<span onClick={() => setMostrar(true)}>{children}</span>
		<Modal show={mostrar} backdrop="static" onHide={() => { setMostrar(false) }} size="lg" centered fullscreen={"sm-down"}>
			<Modal.Header closeButton>Seleccione Módulo</Modal.Header>
			<Modal.Body>
				<Row>
					{modules.map((module: any) => {
						return <Col xs={3} key={module.getModuleName()} className="mb-4">
							<Card className="shadow h-100">
								<Card.Header className='bg-dark text-white text-center'>{module.getModuleTitle()}</Card.Header>
								<Card.Body>
									<div className='text-center'>
										<Button variant='outline-dark' onClick={() => selection(module)}>{module.getIcon(50)}</Button>
										<div className='small mt-2'>{module.getDescription()}</div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					})}
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Button size="sm" variant="danger" onClick={() => setMostrar(false)}><XLg /> Cancelar</Button>
			</Modal.Footer>
		</Modal>
	</>
}
export const ModuleControls: React.FC<{ data: ModuleData, onUpdate: Function, nav: any[], fullNav: any[] }> = ({ data, onUpdate, nav, fullNav }) => {

	const handleChange = (field: ModuleField, value: any) => {
		onUpdate(field, value)
	}

	return <>
		{data.Module!.getFields().map(field => {
			var control = null
			var value = data.Data!.get(field.name) ? data.Data!.get(field.name) : field.default
			switch (field.type) {
				case "text":
					control = <FormControl type="text" onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} />
					break;
				case "number":
					control = <FormControl type="number" onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} className="w-auto" />
					break;
				case "select":
					control = <FormSelect onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} className="w-auto">
						{field.elements?.map((item) => <option key={item.value} value={item.value}>{item.title}</option>)}
					</FormSelect>
					break;
				case "textarea":
					control = <FormControl type="text" as={"textarea"} onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} />
					break;
				case "editor":
					control = <Editor init={{ ...config_editor, height: 400 }} onChange={(ev) => handleChange(field, ev.target.getContent())} value={value} onEditorChange={(content, editor) => editor.save()} />
					break;
				case "check":
					control = <FormCheck type="switch" checked={value === "1"} label={field.description} onChange={(e: any) => {
						handleChange(field, e.target.checked ? "1" : "0");
					}} />
					break;
				case "content":
					control = <ContentSelector value={value} onChange={(data: any) => handleChange(field, data)} />
					break;
				case "nav":
					control = <FormSelect onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} className="w-auto">
						<option value="">Seleccione...</option>
						<option value="-1">Usar navegación</option>
						{nav.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}
					</FormSelect>
					break;
				case "fullnav":
					control = <FormSelect onChange={(ev) => handleChange(field, ev.target.value)} value={value} size="sm" title={field.description} required={field.required} className="w-auto">
						<option value="">Seleccione...</option>
						<option value="-1">Usar navegación</option>
						{fullNav.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}
					</FormSelect>
					break;
				case "tags":
					control = <>
						<TagList list={value} />
						<TagSelector current={value} onSelect={(tags: any) => handleChange(field, tags)}>
							<Button size="sm" variant="secondary"><Gear /></Button>
						</TagSelector>
					</>
					break;
				case "custom":
					if (field.controls) {
						control = <field.controls value={value} onChange={(data: any) => handleChange(field, data)} nav={nav} fullNav={fullNav} config={data.Data!} />
					}
					break;
			}

			return <div key={field.name} style={{ display: "flex", flexDirection: "row" }} className="border-bottom">
				<div style={{ width: 150, display: "flex", alignItems: "center" }} title={field.description}>
					{field.title}
				</div>
				<div className="py-1 w-100">
					{control}
				</div>
			</div>
		})}
	</>
}
export const ModulePanel: React.FC<{ data: ModuleData, index: number, onDrop?: Function, collapse?: Function, remove: Function, update: Function, nav: any[], fullNav: any[] }> = ({ data, index, onDrop, collapse, remove, update, nav, fullNav }) => {
	return <>
		<div draggable={onDrop ? true : false}
			onDragStart={(ev) => { ev.dataTransfer.setData("item", index + "") }}
			onDragOver={(ev) => { ev.preventDefault() }}
			onDrop={(ev) => { if (onDrop) onDrop(ev) }}
			className="bg-secondary text-white px-2 py-1"
			style={{ cursor: onDrop ? "move" : "", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}
		>
			<div>{data.Module!.getIcon(20)} {data.Module!.getModuleTitle()}</div>
			<div>
				{collapse && <Button size="sm" variant="secondary" onClick={() => collapse(data)}><Dash /></Button>}
				<Button size="sm" variant="danger" onClick={() => { if (window.confirm("¿Seguro que desea eliminar?")) remove(data) }}><XLg /></Button>
			</div>
		</div>
		<div className="border px-2">
			{!data.Collapsed && <ModuleControls data={data} onUpdate={(field: ModuleField, value: any) => { update(data, field, value) }} nav={nav} fullNav={fullNav} />}
		</div>
	</>
}